import './DateCell.scss';
import { GridCellProps } from '@progress/kendo-react-grid';
import { DATE_FORMAT } from '../../constants';
import { formatAppDate } from '../../hooks/utils';

export function DateCell({ dataItem, field }: GridCellProps) {
  if (dataItem[field ?? '']) {
    return <td className="date-cell">{formatAppDate(dataItem[field as string], DATE_FORMAT)}</td>;
  }
  return <td></td>;
}
